export const CHARGING_STATION_TABS = {
  BBOX: 'Bounding Box',
  ALONG_THE_ROUTE: 'Along the route',
};
